"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isToday = exports.isYesterday = exports.isTomorrow = exports.utc = exports.isBetween = exports.minMax = exports.preciseDiff = exports.calendar = exports.dayjs = void 0;
require("./tomorrow");
require("./toLocaleDate");
require("./parseLocaleDate");
require("./isSameOrAfter");
require("./nextHour");
require("dayjs/locale/de");
const dayjs_1 = __importDefault(require("dayjs"));
exports.dayjs = dayjs_1.default;
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
const calendar_1 = __importDefault(require("dayjs/plugin/calendar"));
exports.calendar = calendar_1.default;
const isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
exports.isBetween = isBetween_1.default;
const isoWeek_1 = __importDefault(require("dayjs/plugin/isoWeek"));
const isToday_1 = __importDefault(require("dayjs/plugin/isToday"));
exports.isToday = isToday_1.default;
const isTomorrow_1 = __importDefault(require("dayjs/plugin/isTomorrow"));
exports.isTomorrow = isTomorrow_1.default;
const isYesterday_1 = __importDefault(require("dayjs/plugin/isYesterday"));
exports.isYesterday = isYesterday_1.default;
const minMax_1 = __importDefault(require("dayjs/plugin/minMax"));
exports.minMax = minMax_1.default;
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
exports.utc = utc_1.default;
const weekday_1 = __importDefault(require("dayjs/plugin/weekday"));
const calendar_2 = require("./calendar");
const preciseDiff_1 = __importDefault(require("./preciseDiff"));
exports.preciseDiff = preciseDiff_1.default;
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(calendar_1.default);
dayjs_1.default.extend(isBetween_1.default);
dayjs_1.default.extend(isoWeek_1.default);
dayjs_1.default.extend(minMax_1.default);
dayjs_1.default.extend(preciseDiff_1.default);
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(isTomorrow_1.default);
dayjs_1.default.extend(isYesterday_1.default);
dayjs_1.default.extend(isToday_1.default);
// config has to be called/set on exported dayjs instance
(0, calendar_2.initializeLocaleConfig)(dayjs_1.default);
dayjs_1.default.locale('de');
